
export const testimonials = [
  {
    id: 1,
    name: 'Sarah Chen',
    role: 'Marketing Director, Glossier',
    quote: 'Working with Alex has been transformative for our brand. Her authentic approach to content creation resonates deeply with our audience, and the engagement metrics speak for themselves. She truly understands how to tell a brand story.'
  },
  {
    id: 2,
    name: 'Michael Rodriguez',
    role: 'Brand Manager, Everlane',
    quote: 'Alex brings an incredible level of professionalism and creativity to every project. Her content not only looks beautiful but drives real results. The ROI on our collaboration exceeded all expectations.'
  },
  {
    id: 3,
    name: 'Emily Thompson',
    role: 'CEO, Kith NYC',
    quote: 'As a NYC-based brand, finding a creator who truly captures the city\'s energy was crucial. Alex delivered beyond our expectations with content that feels authentic, engaging, and perfectly aligned with our brand values.'
  },
  {
    id: 4,
    name: 'David Park',
    role: 'Creative Director, Milk Makeup',
    quote: 'Alex has an exceptional eye for detail and a natural ability to connect with audiences. Her content consistently outperforms our benchmarks, and her collaborative spirit makes every project a pleasure.'
  }
];
